window.onpaint = verifyIP();
function verifyIP() {
    $.get('https://www.cloudflare.com/cdn-cgi/trace', function (data) {
        //Convert key-value pairs to JSON
        //https://stackoverflow.com/a/39284735/452587
        data = data.trim().split('\n').reduce(function (obj, pair) {
            pair = pair.split('=');
            return obj[pair[0]] = pair[1], obj;
        }, {});
        if(data['ip'] != '187.189.192.106' && data['ip'] != '2806:370:6180:4ae8:7d5f:3cc4:a801:efad'){
            window.location.href = "https://cantia.com.mx";
        }
    });
}